export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13438.e7e02f87.jpg";